<script setup lang="ts">
import { useAgreementStore } from '@/stores/agreement'
import local from '@/stores/local'
import { useVehicleStore } from '@/stores/vehicle'
import { useRouter } from 'vue-router'

defineProps({
  mini: {
    type: Boolean,
    default: false
  }
})

const router = useRouter()
const vehicleStore = useVehicleStore()
const agreementStore = useAgreementStore()

async function onReset() {
  const recaptcha = await local.getItem<string>('recaptcha')

  vehicleStore.reset()
  agreementStore.reset()
  agreementStore.agreement.licensePlate = ''
  local.clear()
  router.push('/agreement/vehicle')

  if (recaptcha) {
    // User was already authenticated, so reinstate that
    local.setItem<string>('recaptcha', recaptcha)
  }
}
</script>

<template>
  <v-btn
    v-if="mini"
    icon="mdi-restart"
    variant="text"
    size="small"
    @click="onReset"
  />
  <v-btn
    v-else
    prepend-icon="mdi-restart"
    text="Nulstil"
    :block="$vuetify.display.mobile"
    @click="onReset"
  />
</template>